import { graphql } from './codegen';
export const LOGIN = graphql(`
  mutation Login($email: String!, $password: String!, $isShipper: Boolean!) {
    login(email: $email, password: $password, isShipper: $isShipper)
      @connection(key: "login", filter: ["email"]) {
      user {
        ...User
      }
      token
    }
  }
`);
export const SIGNUP = graphql(`
  mutation ShipperRegister(
    $email: String!,
    $password: String!,
    $invite: String,
    $sex: EnumUserSex,
    $language: EnumUserLanguage!,
    $firstname: String!,
    $lastname: String!,
    $telephone: String!,
    $company: String,
    $recaptchaToken: String,
    ) {
    shipperRegister(email: $email, password: $password, invite: $invite, sex: $sex, language: $language, firstname: $firstname, lastname: $lastname, telephone: $telephone, company: $company, recaptchaToken: $recaptchaToken)
      @connection(key: "shipperRegister", filter: ["email", "invite"]) {
      user {
        ...User
      }
      token
    }
  }
`);
export const USER_QUERY = graphql(`
  query User {
    user {
      ...User
    }
  }
`);
export const COMPANY_QUERY = graphql(`
  query Company {
    company {
        ...Company
    }
  }
`);
export const GET_COMPANY_ORDER = graphql(`
  query GetCompanyOrder($_id: ObjectId, $order: ObjectId) {
    companyOrder(_id: $_id, order: $order) {
      ...CompanyOrder
    }
  }
`);
export const SUBSCRIBE_TO_COMPANY_ORDER = graphql(`
subscription CompanyOrderUpdates($_id: ObjectId!) {
  companyOrderUpdates(_id: $_id) {
    ...CompanyOrder
  }
}
`);
export const RESET_PASSWORD_MUTATION = graphql(`
  mutation ResetPassword($email: String!, $system: SystemEnum!) {
    resetPassword(
        email: $email,
        system: $system) {
      success
    }
  }
`);
export const RESEND_VERIFICATION_MUTATION = graphql(`
  mutation ResendVerification($email: String!, $system: SystemEnum!) {
    resendVerification(
      email: $email,
      system: $system
    ) {
      success
    }
  }
`);
export const GET_COMPANY_ORDERS_OVERVIEW = graphql(`
  query CompanyOrdersOverview($query: CompanyOrderQuery, $paginate: Pagination) {
    companyOrders(query: $query, paginate: $paginate) {
      items {
        ...CompanyOrderOverview
      }
      hasNext
    }
  }
`);
export const GET_COMPANY_ORDERS = graphql(`
  query CompanyOrders($query: CompanyOrderQuery) {
    companyOrders(query: $query) {
      items {
        ...CompanyOrderDetails
      }
      hasNext
    }
  }
`);
export const CREATE_COMPANY_ORDER = graphql(`
  mutation CreateCompanyOrder($data: CompanyOrderInput, $fusedCompanyOrdersIds: [ObjectId!]) {
    createCompanyOrder(data: $data, fusedCompanyOrdersIds: $fusedCompanyOrdersIds) {
        ...CompanyOrder
      }
  }
`);
export const PAGINATED_CONNECTED_CARRIERS = graphql(`
  query PaginatedConnectedCarriers ($sortBy: ShipperConnectionSortBy, $paginate: Pagination){
    paginatedConnectedCarriers (sortBy: $sortBy, paginate: $paginate){
      items{
        ...ShipperConnectionGroupsPopulated
      }
      hasNext
    }
  }
`);
export const CONNECTED_CARRIERS = graphql(`
  query ConnectedCarriers ($sortBy: ShipperConnectionSortBy){
    connectedCarriers (sortBy: $sortBy){
      ...ShipperConnectionGroupsPopulated
    }
  }
`);
export const ASSIGN_TO_CARRIER = graphql(`
  mutation AssignToCarrier($order: ObjectId!, $carrier: ObjectId!) {
    assignToCarrier(order: $order, carrier: $carrier) {
      ...CompanyOrder
    }
  }
`);
export const RESET_PASSWORD_FINISH_MUTATION = graphql(`
  mutation ResetPasswordFinish($user: String!, $password: String!, $token: String!) {
    resetPasswordFinish(user: $user, password: $password, token: $token)  @connection(key: "resetPasswordFinish", filter: ["user"])  {
      user {
        ...User
      }
      token
    }
  }
`);
export const GET_ADDRESSES = graphql(`
  query Addresses {
    paginatedAddresses {
      items {
        ...Address
      }
    }
  }
`);
export const CREATE_ADDRESS = graphql(`
  mutation CreateAddress($data: AddressCreateInput!) {
    createAddress(data: $data) {
      ...Address
    }
  }
`);
export const UPDATE_ADDRESS = graphql(`
  mutation UpdateAddress($data: AddressUpdateInput!, $_id: ObjectId!) {
    updateAddress(data: $data, _id: $_id) {
      ...Address
    }
  }
`);
export const DELETE_ADDRESS = graphql(`
  mutation DeleteAddress($_id: ObjectId!) {
    deleteAddress(_id: $_id)
  }
`);
export const COPY_COMPANY_ORDER = graphql(`
  mutation CopyCompanyOrder($companyOrder: ObjectId!){
    copyCompanyOrder(companyOrder: $companyOrder) {
      ...CompanyOrder
    }
  }
`);
export const ARCHIVE_COMPANY_ORDER = graphql(`
  mutation ArchiveCompanyOrder($companyOrder: ObjectId!, $delete: Boolean){
    archiveCompanyOrder(companyOrder: $companyOrder, delete: $delete)
  }
`);
export const UPDATE_COMPANY_ORDER = graphql(`
  mutation UpdateCompanyOrder($companyOrder: ObjectId!, $data: CompanyOrderUpdateInput) {
    updateCompanyOrder(companyOrder: $companyOrder, data: $data) {
      ...CompanyOrder
    }
  }
`);
export const GET_SIGNEDURL_S3 = graphql(`
  query GetSignedUrl($filename: String!, $setContentDisposition: Boolean) {
    getSignedUrl(filename: $filename, setContentDisposition: $setContentDisposition)
  }
`);
export const GET_ORDER_ETA = graphql(`
  query GetOrderEta($order: ObjectId!) {
    orderEta(order: $order) {
      order
      nextStopsEta {
        etaToStop
      }
    }
  }
`);
export const COMMENT_TEMPLATES = graphql(`
  query CommentTemplates {
    commentTemplates {
      ...CommentTemplate
    }
  }
`);
export const CREATE_COMMENT_TEMPLATE = graphql(`
  mutation CreateCommentTemplate($data: CommentTemplateInput!) {
    createCommentTemplate(data: $data) {
      ...CommentTemplate
    }
  }
`);
export const UPDATE_COMMENT_TEMPLATE = graphql(`
  mutation UpdateCommentTemplate($data: CommentTemplateInput!, $_id: ObjectId!) {
    updateCommentTemplate(data: $data, _id: $_id) {
      ...CommentTemplate
    }
  }
`);
export const DELETE_COMMENT_TEMPLATE = graphql(`
  mutation DeleteCommentTemplate($_id: ObjectId!) {
    deleteCommentTemplate(_id: $_id)
  }
`);
export const EMAIL_EXISTS = graphql(`
  query EmailExists($email: String!) {
    emailExists(email: $email)
  }
`);
export const INVITE_CARRIER = graphql(`
  mutation InviteCarrier($email: String!, $companyName: String, $telephone: String, $lastName: String, $firstName: String, $system: SystemEnum) {
    inviteCarrier(email: $email, companyName: $companyName, telephone: $telephone, lastname: $lastName, firstname: $firstName, system: $system) {
      ...ShipperConnection
    }
  }
`);
export const ENABLE_CARRIER = graphql(`
  mutation EnableCarrier($connectionId: ObjectId!) {
    enableCarrierConnection(connectionId: $connectionId) {
      ...ShipperConnection
    }
  }
`);
export const ACCEPT_CARRIER_CONNECTION = graphql(`
  mutation AcceptCarrierConnection($connectionId: ObjectId!) {
    acceptCarrierConnection(connectionId: $connectionId) {
      ...ShipperConnection
    }
  }
`);
export const DISABLE_CARRIER = graphql(`
  mutation DisableCarrier($connectionId: ObjectId!) {
    disableCarrierConnection(connectionId: $connectionId) {
      ...ShipperConnection
    }
  }
`);
export const DELETE_CARRIER = graphql(`
  mutation DeleteCarrier($connectionId: ObjectId!) {
    deleteCarrierConnection(connectionId: $connectionId)
  }
`);
export const REQUEST_BIDS = graphql(`
  mutation RequestBids($carriers: [ObjectId!]!, $companyOrderId: ObjectId!) {
    requestBids(carriers: $carriers, companyOrderId: $companyOrderId) {
      ...CompanyOrder
    }
  }
`);
export const ACCEPT_BID = graphql(`
mutation AcceptBid($bid: ObjectId!) {
  acceptBid(bid: $bid) {
    ...Bid
  }
}
`);
export const DECLINE_BID = graphql(`
mutation DeclineBid($bid: ObjectId!) {
  declineBid(bid: $bid) {
    ...Bid
  }
}
`);
export const USER_VERIFY_MUTATION = graphql(`
  mutation UserVerify($token: String!, $user: String!) {
    verify(token: $token, user: $user) {
      user {
        ...User
      }
      token
    }
  }
`);
export const UPLOAD_FILES = graphql(`
  mutation UploadFiles($orderId: ObjectId!, $files: [OrderFilesInput]!) {
    uploadFiles(orderId: $orderId, files: $files) {
      ...Order
    }
  }
`);
export const CALCULATE_LEG = graphql(`
  query CalculateLeg($legInput: LegInput!) {
    calculateLeg(legInput: $legInput) {
      _id
      calculatedRoute {
        ...CalculatedRoute
      }
    }
  }
`);
export const CREATE_CHANGE_REQUEST = graphql(`
  mutation CreateChangeRequest($orderId: ObjectId!, $data: ChangeRequestInput!) {
    createChangeRequest(orderId: $orderId, data: $data) {
      ...CompanyOrder
    }
  }
`);
export const GET_CARRIER_GROUPS = graphql(`
  query CarrierGroups {
    carrierGroups {
      _id
      name
      carriers {
        _id
        company
      }
    }
  }
`);
export const ADD_CARRIER_TO_GROUP = graphql(`
  mutation AddCarrierToGroup($connectionId: ObjectId!, $carrierGroupId: ObjectId!) {
    addCarrierToGroup(connectionId: $connectionId, carrierGroupId: $carrierGroupId) {
      _id
      groups {
        _id
      }
    }
  }
`);
export const REMOVE_CARRIER_FROM_GROUP = graphql(`
  mutation RemoveCarrierFromGroup($shipperConnectionId: ObjectId!, $carrierGroupId: ObjectId!) {
    removeCarrierFromGroup(shipperConnectionId: $shipperConnectionId, carrierGroupId: $carrierGroupId) {
      _id
      groups {
        _id
      }
    }
  }
`);
export const CREATE_CARRIER_GROUP = graphql(`
  mutation CreateCarrierGroup ($data: CarrierGroupInput!){
    createCarrierGroup(data: $data) {
      _id
    }
  }
`);
export const DELETE_CARRIER_GROUP = graphql(`
  mutation DeleteCarrierGroup ($carrierGroupId: ObjectId!) {
    deleteCarrierGroup (carrierGroupId: $carrierGroupId)
  }
`);
export const UPDATE_CARRIER_GROUP = graphql(`
  mutation UpdateCarrierGroup ($data: CarrierGroupUpdateInput!, $carrierGroupId: ObjectId!) {
    updateCarrierGroup (data: $data, carrierGroupId: $carrierGroupId) {
      name
    }
  }
`);
export const CHANGE_ORDER_STATUS = graphql(`
mutation ChangeOrderStatus($order: ObjectId!, $status: EnumOrderStatus!) {
  changeOrderStatus(order: $order, status: $status) {
    ...Order
  }
}
`);
export const UNARCHIVE_COMPANY_ORDER = graphql(`
  mutation UnArchiveCompanyOrder($companyOrderId: ObjectId!) {
    unArchiveCompanyOrder (companyOrderId: $companyOrderId) 
  }
`);
export const EXPORT_ORDERS = graphql(`
  mutation ExportOrders($sort: [SortOptionInput!], $filters: [FilterInput!], $view: ObjectId) {
    exportOrders(sort: $sort, filters: $filters, view: $view) {
      ...ExportResult
    }
  }
`);
export const EXPORT_RESULTS = graphql(`
  query ExportResults ($paginate: Pagination) {
    exportResults (paginate: $paginate) {
      items {
        ...ExportResult
      }
      hasNext
    }
  }
`);
export const CHANGE_CARRIER_CONTACT_PERSON = graphql(`
  mutation ChangeCarrierContactPerson ($carrierCompanyId: ObjectId!, $contactPersonEmail: String!){
    changeCarrierContactPerson(carrierCompanyId: $carrierCompanyId, contactPersonEmail: $contactPersonEmail) {
      _id
    }
  }
`);
export const REQUEST_CONTACT_PERSON_CHANGE = graphql(`
  mutation RequestContactPersonChange($email: String!, $carrierCompanyId: ObjectId!) {
    requestContactPersonChange(email: $email, carrierCompanyId: $carrierCompanyId) {
      _id
    }
  }
`);
export const USER_BELONGS_TO_CONNECTED_COMPANY = graphql(`
  query UserBelongsToConnectedCompany($contactPersonEmail: String!, $connectedCompanyId: ObjectId!){
    userBelongsToConnectedCompany(contactPersonEmail: $contactPersonEmail, connectedCompanyId: $connectedCompanyId)
  }
`);
export const CANCEL_BIDS = graphql(`
  mutation CancelBids($orderId: ObjectId!) {
    cancelBids(orderId: $orderId)
  }
`);
export const CANCEL_TAKEOVER = graphql(`
  mutation CancelTakeover($orderId: ObjectId!) {
    cancelTakeover (orderId: $orderId)
  }
`);
export const GET_ADDRESSES_CATEGORIES = graphql(`
  query AddressesCategoriesQuery {
    addressesCategories {
        ...AddressesCategoryData
    }
  }
`);
export const GET_COMPANY_ORDER_ARCHIVED_SUBORDER_STATUS = graphql(`
  query getCompanyOrderArchivedStatus($orderId: ObjectId!){
    companyOrder(order: $orderId) {
      archived
      isSubOrder
    }
  }
`);
export const ESSENTIAL_APP_STATES = graphql(`
  query EssentialAppStates {
    geocodingSettings {
      allowedCountries
    }
  }
`);
export const LOCATION_SUGGESTIONS = graphql(`
  query LocationSuggestions($query: String!, $country: AddressCountry) {
    locationSuggestions(query: $query, country: $country) {
      providerLocationId
      label
      components {
        city
        country
        countryCode
        houseNumber
        postalCode
        street
      }
    }
  }
`);
export const LOCATION_DETAILS_BY_PROVIDER_ID = graphql(`
  query LocationDetailsByProviderId($providerLocationId: String!) {
    locationDetailsByProviderId(providerLocationId: $providerLocationId) {
      providerLocationId
      label
      coordinates {
        lat
        lon
      }
      components {
        city
        country
        houseNumber
        postalCode
        street
        streetAndHouseNumber
      }
      timezone
    }
  }
`);
export const REVERSE_GEOCODE = graphql(`
  query ReverseGeocode($lat: Float!, $lon: Float!) {
    reverseGeocode(lat: $lat, lon: $lon) {
      providerLocationId
      label
      coordinates {
        lat
        lon
      }
      components {
        city
        country
        houseNumber
        postalCode
        street
        streetAndHouseNumber
      }
      timezone
    }
  }
`);
